module.exports = __webpack_public_path__ + "img/ln-black.170ce1b6.svg";